<template>
  <div class="tile is-parent is-vertical">
    <p class="formtitle">Aluno >> {{formtitle}}</p>

    <article class="tile is-child notification formbox">
      <form @submit.prevent="validate">
        <b-field grouped group-multiline>
          <b-field
            class="column is-4"
            label="nome"
            :type="{'is-danger': errors.has('name')}"
            :message="errors.first('name')"
          >
            <b-input v-model="aluno.name" v-validate="'required'" name="name"></b-input>
          </b-field>

          <b-field
            class="column is-4"
            label="sobrenome"
            :type="{'is-danger': errors.has('sobrenome')}"
            :message="errors.first('sobrenome')"
          >
            <b-input v-model="aluno.sobrenome" v-validate="'required'" name="sobrenome"></b-input>
          </b-field>

          <b-field
            class="column is-4"
            label="email"
            :type="{'is-danger': errors.has('email')}"
            :message="errors.first('email')"
          >
            <b-input v-model="aluno.email" v-validate="'required|email'" name="email"></b-input>
          </b-field>

          <b-field
            class="column is-4"
            label="senha"
            :type="{'is-danger': errors.has('password')}"
            :message="errors.first('password')"
          >
            <b-input
              v-model="aluno.password"
              password-reveal
              type="password"
              v-validate="'required|min:8'"
              name="password"
            ></b-input>
          </b-field>

          <b-field
            class="column is-4"
            label="CPF"
            :type="{'is-danger': errors.has('cpf')}"
            :message="errors.first('cpf')"
          >
            <b-input v-model="aluno.cpf" v-cleave="masks.cpf" name="cpf"></b-input>
          </b-field>

          <b-field
            class="column is-4"
            label="telefone"
            :type="{'is-danger': errors.has('telefone')}"
            :message="errors.first('telefone')"
          >
            <b-input v-model="aluno.telefone" v-cleave="masks.telefone" name="telefone"></b-input>
          </b-field>

          <b-field
            class="column is-4"
            label="matricula"
            :type="{'is-danger': errors.has('matricula')}"
            :message="errors.first('matricula')"
          >
            <b-input v-model="aluno.matricula" name="matricula"></b-input>
          </b-field>

          <b-field label="Data de Nascimento" class="column is-4">
            <b-datepicker
              v-model="aluno.nascimento"
              placeholder="Data de Nascimento"
              icon="calendar-today"
              :date-formatter="formatter"
            ></b-datepicker>
          </b-field>

          <b-field
            class="column is-4"
            label="turma"
            :type="{'is-danger': errors.has('turma')}"
            :message="errors.first('turma')"
          >
            <b-select
              placeholder="Selecione turma"
              icon="file-document"
              expanded
              v-model="aluno.turma_id"
              v-validate="'required'"
              name="turma"
            >
              <option v-for="turma in turmas" :key="turma.id" :value="turma.id">{{turma.nome}}</option>
            </b-select>
          </b-field>

          <b-field
            class="column is-4"
            label="creditos"
            :type="{'is-danger': errors.has('credito')}"
            :message="errors.first('credito')"
          >
            <b-input v-model="aluno.credito" v-validate="'required'" name="credito"></b-input>
          </b-field>

          <b-field
            class="column is-4"
            label="credito ultilizado"
            :type="{'is-danger': errors.has('credito_ultilizado')}"
            :message="errors.first('credito_ultilizado')"
          >
            <b-input 
            v-model="aluno.credito_ultilizado" 
            name="credito_ultilizado" 
            disabled></b-input>
          </b-field>
        </b-field>

        <div class="control has-text-centered">
          <b-button class="button cancelbutton">Cancelar</b-button>
          <button type="submit" class="button updatebutton" :disabled="!isFormValid">{{buttom}}</button>
        </div>
      </form>
    </article>
  </div>
</template>
<script>

export default {
  data() {
    return {
      masks: {
        cpf: {
          delimiters: [".", ".", "-"],
          blocks: [3, 3, 3, 2],
          numericOnly: true
        },
        telefone: {
          blocks: [2, 4, 4],
          numericOnly: true
        }
      }
    };
  },

  name: "AlunoForm",
  props: ["aluno", "turmas", "buttom", "formtitle"],
  methods: {
    validate() {
      this.$validator.validateAll().then(result => {
        if (result) {
          let self = this;

          this.$emit("formSubmit", self.aluno, () => {});
        }
      });
    },
    formatter(date) {
      return `${date.toLocaleDateString("pt-BR")}`;
    }
  },
  components: {},

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some(key => this.fields[key].invalid);
    }
  },
};
</script>
